import { motion } from "framer-motion";

const STAGES = [
  { title: "YÖNELİM", desc: "Neyi, neden öğreniyoruz? Merak ve niyetle yola çıkarız." },
  { title: "UYGULAMA", desc: "Bilgiyi deneyime dönüştürürüz. Yaparak, deneyerek öğreniriz." },
  { title: "FARKINDALIK", desc: "Ne değişti? Deneyimimizi fark eder, anlamlandırırız." },
  { title: "PAYLAŞIM", desc: "Öğrendiğimizi toplulukla paylaşır, döngüyü yeniden başlatırız." },
];

export function PedagogyCycle() {
  const size = 340;
  const c = size / 2;
  const r = 120;
  return (
    <div data-testid="pedagogy-cycle" className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div className="relative mx-auto" style={{ width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <circle cx={c} cy={c} r={r} fill="none" stroke="#E6D3A7" strokeWidth="1.5" />
          <motion.circle
            cx={c} cy={c} r={r} fill="none" stroke="#C5A15B" strokeWidth="2.5"
            strokeLinecap="round" strokeDasharray="60 700"
            animate={{ strokeDashoffset: [0, -754] }}
            transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
          />
        </svg>
        {STAGES.map((s, i) => {
          const angle = (i / STAGES.length) * 2 * Math.PI - Math.PI / 2;
          const x = c + Math.cos(angle) * r;
          const y = c + Math.sin(angle) * r;
          return (
            <div key={s.title} className="absolute -translate-x-1/2 -translate-y-1/2" style={{ left: x, top: y }}>
              <div className="w-16 h-16 rounded-full bg-brand-green text-brand-offwhite flex items-center justify-center text-center text-[10px] font-semibold tracking-wide leading-tight px-1">
                {s.title}
              </div>
            </div>
          );
        })}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
          <span className="font-serif text-2xl text-brand-green">Bilgelik</span>
          <span className="block font-serif text-2xl text-brand-gold">Pedagojisi™</span>
        </div>
      </div>

      <div className="space-y-6">
        {STAGES.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="flex gap-4"
            data-testid={`pedagogy-stage-${i}`}
          >
            <span className="font-serif text-3xl text-brand-gold w-10 shrink-0">{i + 1}</span>
            <div>
              <h4 className="font-serif text-2xl text-brand-green">{s.title}</h4>
              <p className="text-brand-text/70 text-sm mt-1 leading-relaxed">{s.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
